import { AxiosPromise } from "axios";
import API from "./Api";
import { ACCOUNT } from "./constants";

export default class {
  static account(): AxiosPromise {
    return API.post(ACCOUNT);
  }
}
